export default "__VITE_ASSET__InQuR35F__"